import { useTranslation } from 'react-i18next';
import { func, object } from 'prop-types';
import { useForm } from 'react-hook-form';
import { getError } from 'components/helpers';
import { Field } from 'components/molecules';

const EntityForm = ({ onSubmit, entity }) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    defaultValues: entity || {}
  });

  const validators = {
    name: {
      required: 'required'
    },
    emailDomain: {
      required: 'required'
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} id="entityForm">
      <input type="hidden" />
      <Field
        {...register('name', validators.name)}
        type="text"
        label={`${t('general:name')} *`}
        placeholder={t('general:name')}
        error={t(getError(['name', 'message'], errors))}
      />
      <Field
        {...register('emailDomain', validators.emailDomain)}
        type="text"
        label={`${t('user:email')}`}
        placeholder={t('user:email')}
        error={t(getError(['emailDomain', 'message'], errors))}
      />
    </form>
  );
};

EntityForm.propTypes = {
  onSubmit: func.isRequired,
  entity: object
};

EntityForm.defaultProps = {
  entity: null
};

export default EntityForm;
